import { styled } from '@mui/material/styles';

const ElevatedSvg = styled('svg')(({ theme }) => ({
    borderRadius: 12,
    boxShadow: theme.shadows[3],
    width: 64,
}));

export default ElevatedSvg;
